import React from "react";
import { SERVICES } from "@/lib/brands";
import { Truck, Recycle, Briefcase, Wallet } from "lucide-react";

const ICONS = [Briefcase, Truck, Recycle, Wallet];

const Services = () => {
  return (
    <section
      id="services"
      className="section-pad bg-white relative"
      data-testid="services-section"
    >
      <div className="container-x">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-16">
          <div className="md:col-span-5">
            <div className="eyebrow text-[color:var(--primary)] mb-4">
              ◆ What We Do
            </div>
            <h2 className="font-display text-4xl md:text-6xl uppercase leading-[0.95] tracking-tighter">
              Full-Service <br />
              Metal Recycling.
            </h2>
          </div>
          <p className="md:col-span-7 md:col-start-7 text-black/70 leading-relaxed md:mt-4">
            From individual drop-offs to bulk industrial accounts, both yards
            are built to handle it all. Efficient sorting, advanced processing,
            competitive pricing, and a commitment to environmentally
            responsible practices — every single day.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 border border-black/15 divide-y md:divide-y-0 md:divide-x divide-black/15">
          {SERVICES.map((s, idx) => {
            const Icon = ICONS[idx % ICONS.length];
            return (
              <div
                key={s.title}
                className="p-8 group hover:bg-[color:var(--bg-dark)] hover:text-white transition-colors"
                data-testid={`service-card-${idx}`}
              >
                <div className="w-12 h-12 border-2 border-current grid place-items-center mb-6 group-hover:bg-[color:var(--accent)] group-hover:border-[color:var(--accent)] group-hover:text-white transition-colors">
                  <Icon size={18} />
                </div>
                <div className="eyebrow text-[color:var(--primary)] group-hover:text-[color:var(--accent)] mb-3">
                  {String(idx + 1).padStart(2, "0")} · Service
                </div>
                <h3 className="font-display text-xl uppercase mb-3 leading-tight">
                  {s.title}
                </h3>
                <p className="text-sm opacity-80 leading-relaxed">{s.body}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
